<template>
  <div class="scenario__tab">
    <md-menu>
      <md-button :to="{ name: 'Scenario settings', params: { scenarioId: scenarioId }}">Réglages</md-button>
    </md-menu>
    <md-menu>
      <md-button
        :to="{ name: 'Scenario script', params: { scenarioId: scenarioId }}"
        :disabled="scriptEnabled ? false : true">Script</md-button>
    </md-menu>
    <md-menu>
      <md-button
        :to="{ name: 'Scenario program', params: { scenarioId: scenarioId }}"
        :disabled="programEnabled ? false : true">Programme</md-button>
    </md-menu>
    <md-menu>
      <md-button
        :to="{ name: 'Scenario results', params: { scenarioId: scenarioId }}"
        :disabled="resultsEnabled ? false : true">Résultats</md-button>
    </md-menu>
    <md-menu>
      <md-button
        :to="{ name: 'Scenario refine', params: { scenarioId: scenarioId }}"
        :disabled="refineEnabled ? false : true">Affinage</md-button>
    </md-menu>
  </div>
</template>

<script>
export default {
  name: 'ScenarioHeader',
  props: {
    scenarioId: {
      type: Number,
      required: true
    },
    scenarioState: {
      type: String,
      required: true
    }
  },
  computed: {
    scriptEnabled () {
      return ['settings', 'script', 'refine', 'results', 'generating_frontend_xlsx'].includes(this.scenarioState)
    },
    resultsEnabled () {
      return ['refine', 'results', 'generating_frontend_xlsx'].includes(this.scenarioState)
    },
    refineEnabled () {
      return ['refine', 'results', 'generating_frontend_xlsx'].includes(this.scenarioState)
    },
    programEnabled () {
      return ['refine', 'results', 'generating_frontend_xlsx'].includes(this.scenarioState)
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/ScenarioHeader.vue